import Vue from 'vue';
import de from 'vee-validate/dist/locale/de';
import VeeValidate, {Validator} from 'vee-validate';
//import attributesDe from './validator/attributes/de.js';
import IBAN from "iban";

Validator.localize('de', de);

Validator.extend('iban', (value) => {
    return IBAN.isValid(value);
});

Vue.use(VeeValidate, {
    // dictionary: {
    //     de: {attributes: attributesDe},
    // },
    locale: 'de'
});
